<button mat-raised-button
    [color]="color"
    (click)="executeClick()"
    [disabled]="disabled"
    class="{{class}}"
    [routerLink]="router"
    >
    <span fxLayout="row" style="align-items: center;">
        <app-icon-core *ngIf="icon"
            class="btn-icon-style"
            [icon]="icon"
            [inline]="true"
            >
        </app-icon-core>
        <span *ngIf="text">{{text}}</span>
        <ng-content></ng-content>
    </span>
</button>